export const environment = {
  production: true,
  clientId: 'b83ce2e4-ef9b-4d21-8eed-2c40e8809059',
  authority: 'https://login.microsoftonline.com/1dbedab5-849a-4c83-9c43-46581df437d8',
  scope: 'api://taxiflow-api-prod/Taxiflow.Access'
};
